import React, {Component} from 'react';
import {withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import BottomNavigation from "@material-ui/core/BottomNavigation";
import CssBaseline from "@material-ui/core/CssBaseline";
import ExcelViewer from "./ExcelViewer";
import PDFViewer from "./PDFViewer";
import ImageViewer from "./ImageViewer";

const vspacing = 20;

class FileViewer extends Component {
    constructor(props) {
        super(props);

        this.navBar = React.createRef();
        this.doPage = null;

        let withSpacing = this.props.renderer === 'pdf';

        this.state = {
            withSpacing: withSpacing,
            numPages: 1,
            pageNumber: 1,
            pageWidth: 100,
            cbResize: null,
            renderer: this.props.renderer,
            fileConfig: this.props.fileConfig,
        };

    }

    onDocumentLoadSuccess = ({numPages}) => {
        this.setState({numPages});
    };

    getNavBarHeight = () => {
        return this.navBar && this.navBar.current ? this.navBar.current.clientHeight : 0;
    };

    updateDimensions = () => {
        let state = {
            pageWidth: window.innerWidth - (this.state.withSpacing ? (vspacing * 2.5) : 0),
            pageHeight: window.innerHeight - this.getNavBarHeight() - (this.state.withSpacing ? (vspacing * 2.5) : 0)
        };
        this.setState(state);
        if (this.cbResize) {
            this.cbResize(state.pageWidth, state.pageHeight);
        }
    };

    componentDidMount = () => {
        this.updateDimensions();
        window.addEventListener("resize", this.updateDimensions);
    };
    componentWillUnmount = () => {
        window.removeEventListener("resize", this.updateDimensions);
    };

    render() {
        const {pageNumber, numPages} = this.state;
        const {classes} = this.props;

        return (
            <React.Fragment>
                <CssBaseline/>
                {this.state.renderer === 'image' && (
                    <Grid item xs={12} className={classes.image}>
                        <Grid container spacing={0}
                              direction="row"
                              justify="center"
                              alignItems="center"
                              style={{minHeight: this.state.pageHeight}}
                        >
                            <ImageViewer
                                filename={this.props.filename}
                                width={this.state.pageWidth}
                                height={this.state.pageHeight}
                            />
                        </Grid>
                    </Grid>
                )}
                {this.state.renderer === 'xlsx' && (
                    <div className={classes.excel}>
                        <ExcelViewer
                            filename={this.props.filename}
                            pageNumber={pageNumber}
                            doResize={(cb) => {
                                this.cbResize = cb;
                            }}
                            width={this.state.pageWidth}
                            height={this.state.pageHeight}
                        />
                    </div>
                )}
                {this.state.renderer === 'pdf' && (
                    <PDFViewer
                        filename={this.props.filename}
                        pageNumber={pageNumber}
                        doResize={(cb) => {
                            this.cbResize = cb;
                        }}
                        doPage={(cb) => {
                            this.doPage = cb;
                        }}
                        width={this.state.pageWidth}
                        height={this.state.pageHeight}
                        onDocumentLoadSuccess={this.onDocumentLoadSuccess}
                    />
                )}
                {this.state.renderer !== 'image' && (
                    <BottomNavigation className={classes.stickToBottom} showLabels={true}>
                        <div ref={this.navBar}>
                            <Grid item xs={12}>
                                <Grid container spacing={0}
                                      direction="row"
                                      justify="center"
                                      alignItems="center"
                                >
                                    <Button variant="fab" color="primary" aria-label="left" className={classes.fab}
                                            disabled={!(pageNumber > 1)}
                                            onClick={() => {
                                                this.setState({pageNumber: pageNumber - 1});
                                                if (this.doPage) {
                                                    this.doPage(pageNumber - 1);
                                                }
                                            }}>
                                        <Icon>chevron_left</Icon>
                                    </Button>
                                    <span className={classes.pageNav}>{pageNumber} / {numPages}</span>
                                    <Button variant="fab" color="primary" aria-label="right" className={classes.fab}
                                            disabled={!(numPages > 1 && pageNumber < numPages)}
                                            onClick={() => {
                                                this.setState({pageNumber: pageNumber + 1});
                                                if (this.doPage) {
                                                    this.doPage(pageNumber + 1);
                                                }
                                            }}>
                                        <Icon>chevron_right</Icon>
                                    </Button>
                                </Grid>
                            </Grid>
                        </div>
                    </BottomNavigation>
                )}
            </React.Fragment>
        );
    }
}


const styles = theme => ({
    left: {
        textAlign: "center",
        paddingRight: theme.spacing.unit * 3,
    },
    right: {
        textAlign: "center",
    },
    center: {
        textAlign: "center",
    },
    fab: {
        padding: theme.spacing.unit,
    },
    page: {
        textAlign: "center",
    },
    pageNav: {
        padding: theme.spacing.unit * 2,
    },
    excel: {
        backgroundColor: theme.colors.white,
    },
    document: {
        paddingLeft: vspacing,
        paddingTop: vspacing,
    },
    stickToBottom: {
        backgroundColor: theme.colors.lightGreyBlue,
        width: '100%',
        position: 'fixed',
        bottom: 0,
        paddingBottom: vspacing,
    },
});


export default withStyles(styles)(FileViewer);



// WEBPACK FOOTER //
// ./resources/assets/js/components/File/FileViewer.jsx